<template>
	<div>
		<div style="margin:15px 0">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/shopManage' }">店铺管理</el-breadcrumb-item>
				<el-breadcrumb-item>{{ type === 0 ? '添加' : '编辑' }}店铺</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<el-card class="box-card">
			<el-form :rules="rules" :model="formList" ref="formList">
				<el-form-item label="店铺名称" label-width="80px" prop="shop_name">
					<el-input style="width: 80%" v-model="formList.shop_name" placeholder="请输入店铺名称"></el-input>
				</el-form-item>
				<el-form-item label="店铺地址" label-width="80px" prop="shop_address">
					<el-input style="width: 80%" v-model="formList.shop_address" placeholder="请输入店铺地址"></el-input>
				</el-form-item>
				<el-form-item label="批次号" label-width="80px" prop="stock_ids">
					<el-select v-model.trim="formList.Color020" multiple filterable allow-create style="width: 80%"
							   default-first-option placeholder="请输入批次号">
						<!--					<el-option v-for="item in options"-->
						<!--							:key="item.value"-->
						<!--							:label="item.label"-->
						<!--							:value="item.value">-->
						<!--					</el-option>-->
					</el-select>
				</el-form-item>
				<el-form-item label="绑定景区" label-width="80px" prop="area_id">
					<el-select v-model="formList.area_id" style="width: 80%"
							   filterable placeholder="请选择景区">
						<el-option v-for="item in scenicList" :key="item.area_id"
								   :label="item.area_name" :value="item.area_id">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
		</el-card>
		<span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="save">保存</el-button></span>
	</div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
import qs from "qs";
import coupon from "../api/coupons";
import {uploadPath} from "../axios/index";

export default {
	components: {Editor},
	props: {
		pageSize: {
			type: Number,
			default: 10,
		}
	},
	data() {
		return {
			uploadPath,
			formList: {
				id: undefined,
				shop_name: '',
				shop_address: '',
				stock_ids: [],
				area_id: ''
			},
			scenicList: [],
			type: 0,
			rules: {
				shop_name: [{required: true, message: '请输入店铺名称', trigger: 'blur'}],
				shop_address: [{required: true, message: '请输入店铺地址', trigger: 'blur'}],
				stock_ids: [{required: true, message: '请输入批次号', trigger: 'change'}],
				area_id: [{required: true, message: '请选择景区', trigger: 'change'}],
			},
		}
	},
	mounted() {
		this.getScenicArea();
		let query = this.$route.query;
		this.type = parseInt(query.type);
		if (this.type === 0) {
		} else if (this.type === 1 && this.$datas.shop.id) {
			let shopInfo = this.$datas.shop.info;
			shopInfo.stock_ids = shopInfo.stock_ids.split(',');
			this.formList = shopInfo;
		} else {
			this.$confirm('请返回重试！', '提示', {
				confirmButtonText: '确定',
				showCancelButton: false,
				type: 'warning'
			}).then(() => {
				this.$router.push({
					path: "/shopManage"
				});
			})
		}
	},
	methods: {
		getScenicArea() {
			coupon.getScenicArea({
				pageindex: 1,
				pagesize: 1000
			}).then(res => {
				this.scenicList = res.list;
			})
		},
		add(i, data) {//添加券包
			this.formList.area_name = data.area_name;
			this.pop = true;
			console.log(i, data)
		},
		save() {//保存
			let formList = Object.assign({}, this.formList);
			formList.stock_ids = formList.stock_ids.join();
			this.$refs.formList.validate((valid) => {
				if (valid) {
					if (this.type === 0) {//添加
						coupon.addCouponShop(formList).then(id => {
							this.cancel();
						}).catch(err => {
							this.$message({
								type: 'error',
								message: err.msg
							});
						})
					} else if (this.type === 1) {//修改
						coupon.updateCouponShop(formList).then(res => {
							this.cancel();
						}).catch(err => {
							this.$message({
								type: 'error',
								message: err.msg
							});
						})
					}
				}
			})
		},
		cancel() {
			this.$router.push({
				path: "/shopManage"
			});
		},
	},
}
</script>

<style>
p span {
	margin: 0 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/shopAdd.vue